// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LAKPED-8 — Pedidos.
   Todo acotado a .orders-container: el CSS de CRA es global y una regla suelta
   (p.ej. \`.pagination button\` de AccountConsumptionPage) pisa lo que no esté acotado. */
.orders-container {
  padding: 40px;
  max-width: 1400px;
  margin: 0 auto;
}

.orders-title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 24px;
  color: #000;
}

.orders-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.orders-container .orders-search {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 320px;
  max-width: 460px;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  color: #999;
  transition: border-color 0.15s ease;
}

.orders-container .orders-search:focus-within {
  border-color: var(--button-color);
  color: var(--button-color);
}

.orders-container .orders-search input {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 14px;
  color: #000;
  background: transparent;
}

.orders-container .orders-search-clear {
  border: none;
  background: transparent;
  color: #999;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  padding: 0 2px;
}

.orders-container .orders-search-clear:hover { color: #333; }

.orders-status-filter {
  display: inline-flex;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

/* Grises fijos y la variable de tema solo para el estado activo: --button-color
   puede ser claro en algún cliente y el texto blanco desaparecería. */
.orders-container .orders-status-btn {
  border: none;
  background: #fff;
  color: #555;
  font-size: 13px;
  padding: 8px 16px;
  cursor: pointer;
  border-right: 1px solid #ececec;
  transition: background 0.15s ease, color 0.15s ease;
}

.orders-container .orders-status-btn:last-child { border-right: none; }
.orders-container .orders-status-btn:hover { background: #fafafa; color: var(--button-color); }

.orders-container .orders-status-btn.active {
  background: #f2f2f2;
  color: #000;
  font-weight: 600;
  box-shadow: inset 0 -2px 0 var(--button-color);
}

.orders-error {
  padding: 12px 16px;
  margin-bottom: 16px;
  border-radius: 8px;
  background: #fee2e2;
  color: #991b1b;
  font-size: 14px;
}

/* Único sitio con scroll horizontal permitido, y solo si no cabe */
.orders-table-wrapper { overflow-x: auto; }

.orders-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}

.orders-table thead {
  background: var(--button-color);
  color: #fff;
}

.orders-table th {
  padding: 14px 16px;
  text-align: left;
  font-weight: 500;
  font-size: 14px;
  white-space: nowrap;
  border-right: 1px solid var(--hover-color);
}

.orders-table th:last-child { border-right: none; }

.orders-table td {
  padding: 13px 16px;
  font-size: 14px;
  color: #000;
  border-right: 1px solid #ececec;
  vertical-align: top;
}

.orders-table td:last-child { border-right: none; }
.orders-table tbody tr:nth-child(even) { background: var(--background-color); }

.orders-container .orders-row { cursor: pointer; }
.orders-container .orders-row:hover { background: #e8e8e8; }

.orders-table .col-num { text-align: right; white-space: nowrap; }
.orders-table .col-estado { text-align: center; white-space: nowrap; }
.orders-table .col-cliente { font-weight: 500; }
.orders-table .col-ref { color: #444; white-space: nowrap; }

/* La columna del trabajo es la flexible: absorbe el espacio sobrante
   y el nombre del plano va DEBAJO, que al lado robaría ancho. */
.orders-table .col-trabajo { width: 42%; }

.orders-desc {
  color: #222;
  overflow-wrap: anywhere;
  /* Hay descripciones con 15 referencias seguidas: sin recortar hacen filas de
     4 líneas y la tabla pierde el ritmo. El detalle del pedido las muestra enteras. */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.orders-plano {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-top: 4px;
  font-size: 12px;
  color: #6b6b6b;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.orders-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.orders-badge.abierto { background: #dbeafe; color: #1e40af; }
.orders-badge.cerrado { background: #d1fae5; color: #065f46; }

.orders-empty {
  text-align: center;
  padding: 48px 16px;
  color: #777;
  font-size: 15px;
}



@media (max-width: 760px) {
  .orders-container { padding: 20px 16px; }
  .orders-toolbar { flex-direction: column; align-items: stretch; }
}

/* Cabecera con el alta desde documento escaneado (LAKPED-7) */
.orders-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 24px;
}

.orders-head .orders-title { margin-bottom: 0; }

.orders-container .orders-new {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 16px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: var(--button-color);
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.orders-container .orders-new:hover { opacity: 0.9; }

/* Estados de oferta en su listado (comparten estilos con la tabla de pedidos) */
.orders-table .offer-badge { padding: 4px 12px; border-radius: 12px; font-size: 12px; font-weight: 500; }
.orders-table .offer-badge.draft { background: #f1f1f1; color: #555; }
.orders-table .offer-badge.sent { background: #dbeafe; color: #1e40af; }
.orders-table .offer-badge.accepted { background: #d1fae5; color: #065f46; }
.orders-table .offer-badge.rejected { background: #fee2e2; color: #991b1b; }
.orders-table .offer-badge.expired { background: #ffedd5; color: #c2410c; }

/* LAKPED-16: filtro por cliente en el seguimiento de ofertas. Lo pidió Paula para ver de un
   vistazo cuántas ofertas se le han hecho a cada uno y cuántas ha aceptado. */
.orders-container .orders-cliente {
  font: inherit;
  font-size: 13px;
  padding: 7px 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;
  color: #333;
  margin-left: 8px;
  max-width: 240px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/OrdersPage.css"],"names":[],"mappings":"AAAA;;wFAEwF;AACxF;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,+CAA+C,WAAW,EAAE;;AAE5D;EACE,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;sEACsE;AACtE;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,mDAAmD;AACrD;;AAEA,kDAAkD,kBAAkB,EAAE;AACtE,6CAA6C,mBAAmB,EAAE,0BAA0B,EAAE;;AAE9F;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA,mEAAmE;AACnE,wBAAwB,gBAAgB,EAAE;;AAE1C;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,8BAA8B,kBAAkB,EAAE;;AAElD;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,8BAA8B,kBAAkB,EAAE;AAClD,yCAAyC,mCAAmC,EAAE;;AAE9E,gCAAgC,eAAe,EAAE;AACjD,sCAAsC,mBAAmB,EAAE;;AAE3D,yBAAyB,iBAAiB,EAAE,mBAAmB,EAAE;AACjE,4BAA4B,kBAAkB,EAAE,mBAAmB,EAAE;AACrE,6BAA6B,gBAAgB,EAAE;AAC/C,yBAAyB,WAAW,EAAE,mBAAmB,EAAE;;AAE3D;gEACgE;AAChE,6BAA6B,UAAU,EAAE;;AAEzC;EACE,WAAW;EACX,uBAAuB;EACvB;sFACoF;EACpF,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;;AAE7D;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;;;AAIA;EACE,oBAAoB,kBAAkB,EAAE;EACxC,kBAAkB,sBAAsB,EAAE,oBAAoB,EAAE;AAClE;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA,6BAA6B,gBAAgB,EAAE;;AAE/C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;;AAEA,sCAAsC,YAAY,EAAE;;AAEpD,gFAAgF;AAChF,6BAA6B,iBAAiB,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACxG,mCAAmC,mBAAmB,EAAE,WAAW,EAAE;AACrE,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,sCAAsC,mBAAmB,EAAE,cAAc,EAAE;AAC3E,sCAAsC,mBAAmB,EAAE,cAAc,EAAE;AAC3E,qCAAqC,mBAAmB,EAAE,cAAc,EAAE;;AAE1E;8EAC8E;AAC9E;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":["/* LAKPED-8 — Pedidos.\n   Todo acotado a .orders-container: el CSS de CRA es global y una regla suelta\n   (p.ej. `.pagination button` de AccountConsumptionPage) pisa lo que no esté acotado. */\n.orders-container {\n  padding: 40px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.orders-title {\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 24px;\n  color: #000;\n}\n\n.orders-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 18px;\n}\n\n.orders-container .orders-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1 1 320px;\n  max-width: 460px;\n  padding: 8px 12px;\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  color: #999;\n  transition: border-color 0.15s ease;\n}\n\n.orders-container .orders-search:focus-within {\n  border-color: var(--button-color);\n  color: var(--button-color);\n}\n\n.orders-container .orders-search input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 14px;\n  color: #000;\n  background: transparent;\n}\n\n.orders-container .orders-search-clear {\n  border: none;\n  background: transparent;\n  color: #999;\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0 2px;\n}\n\n.orders-container .orders-search-clear:hover { color: #333; }\n\n.orders-status-filter {\n  display: inline-flex;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #fff;\n}\n\n/* Grises fijos y la variable de tema solo para el estado activo: --button-color\n   puede ser claro en algún cliente y el texto blanco desaparecería. */\n.orders-container .orders-status-btn {\n  border: none;\n  background: #fff;\n  color: #555;\n  font-size: 13px;\n  padding: 8px 16px;\n  cursor: pointer;\n  border-right: 1px solid #ececec;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.orders-container .orders-status-btn:last-child { border-right: none; }\n.orders-container .orders-status-btn:hover { background: #fafafa; color: var(--button-color); }\n\n.orders-container .orders-status-btn.active {\n  background: #f2f2f2;\n  color: #000;\n  font-weight: 600;\n  box-shadow: inset 0 -2px 0 var(--button-color);\n}\n\n.orders-error {\n  padding: 12px 16px;\n  margin-bottom: 16px;\n  border-radius: 8px;\n  background: #fee2e2;\n  color: #991b1b;\n  font-size: 14px;\n}\n\n/* Único sitio con scroll horizontal permitido, y solo si no cabe */\n.orders-table-wrapper { overflow-x: auto; }\n\n.orders-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #fff;\n}\n\n.orders-table thead {\n  background: var(--button-color);\n  color: #fff;\n}\n\n.orders-table th {\n  padding: 14px 16px;\n  text-align: left;\n  font-weight: 500;\n  font-size: 14px;\n  white-space: nowrap;\n  border-right: 1px solid var(--hover-color);\n}\n\n.orders-table th:last-child { border-right: none; }\n\n.orders-table td {\n  padding: 13px 16px;\n  font-size: 14px;\n  color: #000;\n  border-right: 1px solid #ececec;\n  vertical-align: top;\n}\n\n.orders-table td:last-child { border-right: none; }\n.orders-table tbody tr:nth-child(even) { background: var(--background-color); }\n\n.orders-container .orders-row { cursor: pointer; }\n.orders-container .orders-row:hover { background: #e8e8e8; }\n\n.orders-table .col-num { text-align: right; white-space: nowrap; }\n.orders-table .col-estado { text-align: center; white-space: nowrap; }\n.orders-table .col-cliente { font-weight: 500; }\n.orders-table .col-ref { color: #444; white-space: nowrap; }\n\n/* La columna del trabajo es la flexible: absorbe el espacio sobrante\n   y el nombre del plano va DEBAJO, que al lado robaría ancho. */\n.orders-table .col-trabajo { width: 42%; }\n\n.orders-desc {\n  color: #222;\n  overflow-wrap: anywhere;\n  /* Hay descripciones con 15 referencias seguidas: sin recortar hacen filas de\n     4 líneas y la tabla pierde el ritmo. El detalle del pedido las muestra enteras. */\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.orders-plano {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  margin-top: 4px;\n  font-size: 12px;\n  color: #6b6b6b;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.orders-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.orders-badge.abierto { background: #dbeafe; color: #1e40af; }\n.orders-badge.cerrado { background: #d1fae5; color: #065f46; }\n\n.orders-empty {\n  text-align: center;\n  padding: 48px 16px;\n  color: #777;\n  font-size: 15px;\n}\n\n\n\n@media (max-width: 760px) {\n  .orders-container { padding: 20px 16px; }\n  .orders-toolbar { flex-direction: column; align-items: stretch; }\n}\n\n/* Cabecera con el alta desde documento escaneado (LAKPED-7) */\n.orders-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 24px;\n}\n\n.orders-head .orders-title { margin-bottom: 0; }\n\n.orders-container .orders-new {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 9px 16px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: var(--button-color);\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n}\n\n.orders-container .orders-new:hover { opacity: 0.9; }\n\n/* Estados de oferta en su listado (comparten estilos con la tabla de pedidos) */\n.orders-table .offer-badge { padding: 4px 12px; border-radius: 12px; font-size: 12px; font-weight: 500; }\n.orders-table .offer-badge.draft { background: #f1f1f1; color: #555; }\n.orders-table .offer-badge.sent { background: #dbeafe; color: #1e40af; }\n.orders-table .offer-badge.accepted { background: #d1fae5; color: #065f46; }\n.orders-table .offer-badge.rejected { background: #fee2e2; color: #991b1b; }\n.orders-table .offer-badge.expired { background: #ffedd5; color: #c2410c; }\n\n/* LAKPED-16: filtro por cliente en el seguimiento de ofertas. Lo pidió Paula para ver de un\n   vistazo cuántas ofertas se le han hecho a cada uno y cuántas ha aceptado. */\n.orders-container .orders-cliente {\n  font: inherit;\n  font-size: 13px;\n  padding: 7px 10px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background: #fff;\n  color: #333;\n  margin-left: 8px;\n  max-width: 240px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
